// Shell feature routes: calendar, notifications, profile, company, /login/force.

import { Navigate } from 'react-router-dom';

import type { FeatureRoute } from '../registry';
import { CalendarPage } from './CalendarPage';
import { CompanyPage } from './CompanyPage';
import { ForceLoginPage } from './ForceLoginPage';
import { NotificationsPage } from './NotificationsPage';
import { ProfilePage } from './ProfilePage';

export const routes: FeatureRoute[] = [
  { path: 'calendar', element: <CalendarPage /> },
  // The legacy events screen is the calendar (the events list endpoint is
  // month-grouped and cannot back a CRUD table).
  { path: 'events', element: <Navigate to="/calendar" replace /> },
  { path: 'notifications', element: <NotificationsPage /> },
  { path: 'profile', element: <ProfilePage /> },
  { path: 'change-password', element: <Navigate to="/profile?tab=password" replace /> },
  { path: 'company', element: <CompanyPage /> }
];

export const publicRoutes: FeatureRoute[] = [{ path: 'login/force', element: <ForceLoginPage /> }];
